import {
	PORTFOLIO_CATEGORY_ORDER,
	type PortfolioCategoryId,
} from "web_myplann/Portfolio/Types/portfolioCategory";

export const hiddenPortfolioCategories = (
	categories: PortfolioCategoryId[],
): PortfolioCategoryId[] =>
	categories.length === 0
		? []
		: PORTFOLIO_CATEGORY_ORDER.filter((id) => !categories.includes(id));
